define('TescoMobile_Iovation/js/iovation',['./action/set-device-fingerprint', './model/device-fingerprint-config', './iovation-loader'], function (setDeviceFingerprintAction, fingerprintConfig, iovationLoader) {
  'use strict';

  return function (config) {
    let fingerprintSent = false;
    let igloo = {
      "enable_flash": false,
      "loader": {
        "version": "general5"
      }
    };
    if (typeof config.selector !== "undefined") {
      igloo.bbout_element_id = config.selector;
    } else if (typeof config.callback !== "undefined") {
      igloo.bb_callback = function (token, complete) {
        if (fingerprintConfig.isFingerprintSaved === true || fingerprintSent === true) {
          return;
        }
        if (complete) {
          fingerprintSent = true;
          setDeviceFingerprintAction(config.callback, token).done(function () {
            fingerprintConfig.isFingerprintSaved = true;
          });
        }
      };
    }
    window.io_global_object_name = "IGLOO";
    window.IGLOO = window.IGLOO || igloo;
    iovationLoader();
  };
});

